import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { cssMainSelector } from "../lib/cssSelectors";
import styled from "styled-components";
import { CSS_CLASS_PREFIX } from "../constants/css";

const VariantsWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    display: inline;
  }
`;

const Variant = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.theme.color.white};
    border-radius: ${p => p.theme.generic.borderRadius};
    box-shadow: 0 1px 3px 0 ${p => p.theme.color.darkLavender};
    cursor: pointer;
    display: inline-block;
    height: 34px;
    position: relative;
    width: 42px;

    &.${CSS_CLASS_PREFIX}-first-and-last-phone-variant {
      border-radius: 100px 100px 100px 100px;
    }

    &.${CSS_CLASS_PREFIX}-first-phone-variant {
      border-radius: 100px 0 0 100px;
    }

    &.${CSS_CLASS_PREFIX}-last-phone-variant {
      border-radius: 0 100px 100px 0;
    }

    &.${CSS_CLASS_PREFIX}-selected-phone-variant,
      &.${CSS_CLASS_PREFIX}-selected-phone-variant:hover {
      background-color: ${p => p.theme.color.lavender};
      box-shadow: inset 0 1px 2px 0 ${p => p.theme.color.silver};
      cursor: auto;
    }

    &:hover {
      background-color: ${p => p.theme.color.aliceBlue};
    }
  }
`;

const VariantColor = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.primaryColor};
    border-radius: ${p => p.theme.generic.borderRadius};
    display: inline-block;
    height: 14px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 14px;
  }
`;

class PhoneVariantSelector extends PureComponent {
  render() {
    try {
      return <VariantsWrapper>{this.phoneVariantBlocks()}</VariantsWrapper>;
    } catch (e) {
      return null;
    }
  }

  phoneVariantBlocks() {
    const {
      phoneVariant,
      phoneVariants,
      updateFilterPhoneVariantId
    } = this.props;
    const items = [];
    let i = 1;
    let totalCount = phoneVariants.length;

    for (const variant of phoneVariants) {
      let firstLastClass = "";
      let selectedClass = "";

      if (phoneVariant != null && phoneVariant.id === variant.id) {
        selectedClass = `${CSS_CLASS_PREFIX}-selected-phone-variant`;
      }

      if (i === 1 && i === totalCount) {
        firstLastClass = `${CSS_CLASS_PREFIX}-first-and-last-phone-variant`;
      } else if (i === 1) {
        firstLastClass = `${CSS_CLASS_PREFIX}-first-phone-variant`;
      } else if (i === totalCount) {
        firstLastClass = `${CSS_CLASS_PREFIX}-last-phone-variant`;
      }

      const extraClasses = `${selectedClass} ${firstLastClass}`;

      if (phoneVariant != null && phoneVariant.id === variant.id) {
        items.push(
          <Variant key={i} className={`${extraClasses}`}>
            <VariantColor
              primaryColor={variant.primaryColor}
              secondaryColor={variant.secondaryColor}
            />
          </Variant>
        );
      } else {
        items.push(
          <Variant
            key={i}
            className={`${extraClasses}`}
            onClick={updateFilterPhoneVariantId.bind(this, variant.id)}
          >
            <VariantColor
              primaryColor={variant.primaryColor}
              secondaryColor={variant.secondaryColor}
            />
          </Variant>
        );
      }

      i += 1;
    }

    return items;
  }
}

PhoneVariantSelector.propTypes = {
  phoneVariant: PropTypes.object,
  phoneVariants: PropTypes.array.isRequired,
  updateFilterPhoneVariantId: PropTypes.func.isRequired
};

export default PhoneVariantSelector;
